export default __webpack_public_path__ + "static/media/icon_youtube.89365dbf.svg";